import { isLoggedIn } from '@utils/auth'
import { getCITypeApi } from './api'
import Constants from '@constants'
export const state = {
  ciTypes: [],
}

export const getters = {
  ciTypes(state) {
    return state.ciTypes
  },
}

export const mutations = {
  SET_CI_TYPE(state, data) {
    state.ciTypes = data
  },
}

export const actions = {
  init({ dispatch }) {
    if (isLoggedIn()) {
      dispatch('fetch')
    }
  },

  fetch({ commit, rootGetters }) {
    const availableModules = rootGetters['license/availableModules']
    if (availableModules.indexOf(Constants.CMDB) >= 0) {
      return getCITypeApi().then((data) => {
        commit('SET_CI_TYPE', data)
        return data
      })
    }
  },

  /**
   * destroy all states when user is logged out
   */
  destroy({ commit }) {
    commit('SET_CI_TYPE', [])
  },
}
